<div class="col-md-6 carousel-texts__wrapper order-2 order-md-1">
    <div class="carousel-texts">
        <h1 class="carousel-title">{{item.title}} </h1>
        <p class="carousel-description">{{item.description}}</p>
        <a [href]="item.link">
            <button type="button" class="card-button">
                <span class="card-button-label">Ingresar</span>
            </button>
        </a>
    </div>
</div>

<div class="carousel-banner col-md-6 order-1 order-md-2">
    <img [src]="'../../../assets/images/'+ item.img " [alt]="item.title" class="carousel-img d-block" alt="...">
</div>
